<template>
  <div class="shop_list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        用户列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="goodslist_top">
        <div class="goodslist_title">筛选查询</div>
        <div class="goodslost_seach">
          <el-row class="goodslost_seach_row">
            <el-col :span="8">
              <div class="goodslost_seach_row_col">
                <div>分类:</div>
                <!-- <el-input placeholder="商品名称" v-model="sy_name" style="width:190px" size="mini"></el-input> -->

                <el-select
                  size="small"
                  clearable
                  @change="change_elect"
                  v-model="value"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in classIfy"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="8"></el-col>
            <el-col :span="8" style="text-align:center"></el-col>
          </el-row>
        </div>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div style="margin-left:16px">
              <i class="fas fa-bars"></i>
              <span style="margin-left:6px">数据列表</span>
            </div>

            <div class="center_list_head_left_div">
              <!-- <div class="show_total">
                <el-dropdown trigger="click" @command="change_page_num">
                  <span class="el-dropdown-link show_total_span" style="c">
                    显示条数
                    <i style="font-size: 12px;" class="iconfont icon-sanjiaoxing"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="10">每页10条</el-dropdown-item>
                    <el-dropdown-item :command="15">每页15条</el-dropdown-item>
                    <el-dropdown-item :command="20">每页20条</el-dropdown-item>
                    <el-dropdown-item :command="50">每页50条</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>-->
              <div class="show_total" @click="dialogFormVisible1 = true">添加商品</div>
            </div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table
        :header-cell-style="{'background':'#F5FAF9'}"
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        @row-click="indexMethod"
      >
        <el-table-column align="center" prop="order_by" label="图片" width="80">
          <template slot-scope="scope">
            <div>
              <img style="width:60px;height:60px" :src="scope.row.image" alt />
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="create_date" label="发布时间" width="110"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="number" label="数量"></el-table-column>
        <el-table-column align="center" prop="other" label="更多要求" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="product_title" label="产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="purchaser" label="采购方" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="standard" label="标准类型" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="title" label="标题" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="use_sence" label="使用场景" show-overflow-tooltip></el-table-column>
        <el-table-column width="120" align="center" label="操作">
          <template slot-scope="scope">
            <span class="binaji" @click="edit(scope.row.id,page)">编辑</span>
            <span class="binaji" @click="setgoods(scope.row.id,page)">删除</span>
            <!-- <span
              class="binaji"
              @click="goodsdelete(scope.row.id)"
            >{{scope.row.forbidden == '0' ? '禁用' : '开启'}}</span>-->
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-pagination
          class="goodslist_bom_page"
          background
          layout="total , prev, pager, next"
          :page-size="limit"
          :total="total"
          @current-change="pagechange"
          hide-on-single-page
        ></el-pagination>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 添加用户 -->
    <el-dialog title="添加商品" :visible.sync="dialogFormVisible1" width="50%">
      <el-form size="small">
        <el-form-item label="　采购方:">
          <el-input
            style="width:356px"
            placeholder="请输入"
            clearable
            v-model="purchaser"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="　　标题">
          <el-input
            style="width:356px"
            placeholder="请输入"
            clearable
            v-model="title"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品名称:">
          <el-input
            clearable
            style="width:356px"
            placeholder="请输入"
            v-model="product_title"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="　　排序:">
          <el-input
            clearable
            style="width:356px"
            placeholder="请输入"
            v-model="order_by"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="　　分类:">
          <el-select clearable v-model="option_value" placeholder="请选择">
            <el-option v-for="item in classIfy" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="使用场景:">
          <el-input
            style="width:356px"
            clearable
            placeholder="请输入"
            v-model="use_sence"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="　　数量:">
          <el-input
            style="width:356px"
            clearable
            placeholder="请输入"
            v-model="number"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="　　标准:">
          <el-input
            style="width:356px"
            clearable
            placeholder="请输入"
            v-model="standard"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="　　图片:">
          <el-upload
            ref="upload"
            class="upload-demo"
            :auto-upload="false"
            :on-change="prove_img_file"
            :limit="1"
            action
          >
            <el-button>添加图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="更多要求:">
          <el-input
            placeholder="请输入"
            clearable
            style="width:356px"
            v-model="other"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="addsubmit()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog title="编辑商品" :visible.sync="dialogFormVisible2" width="50%">
      <el-form size="small">
        <el-form-item label="　采购方:">
          <el-input
            style="width:356px"
            placeholder="请输入"
            clearable
            v-model="edit_obj.purchaser"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="　　标题">
          <el-input
            style="width:356px"
            placeholder="请输入"
            clearable
            v-model="edit_obj.title"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品名称:">
          <el-input
            clearable
            style="width:356px"
            placeholder="请输入"
            v-model="edit_obj.product_title"
            autocomplete="off"
          ></el-input>
        </el-form-item>

         <el-form-item label="　　排序:">
          <el-input
            clearable
            style="width:356px"
            placeholder="请输入"
            v-model="edit_obj.order_by"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="　　分类:">
          <el-select clearable v-model="edit_obj.cate_id" placeholder="请选择">
            <el-option v-for="item in classIfy" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="使用场景:">
          <el-input
            style="width:356px"
            clearable
            placeholder="请输入"
            v-model="edit_obj.use_sence"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="　　数量:">
          <el-input
            style="width:356px"
            clearable
            placeholder="请输入"
            v-model="edit_obj.number"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="　　标准:">
          <el-input
            style="width:356px"
            clearable
            placeholder="请输入"
            v-model="edit_obj.standard"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="　　图片:">
          <el-upload
            ref="upload"
            class="upload-demo"
            :auto-upload="false"
            :on-change="edit_img_file"
            :limit="1"
            action
          >
            <div>
              <div>
                <img :src="edit_obj.image" style="width:80px;height:80px" alt />
              </div>
              <el-button>添加图片</el-button>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="更多要求:">
          <el-input
            placeholder="请输入"
            clearable
            style="width:356px"
            v-model="edit_obj.other"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="editsubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role:true,
      options: [
        {
          value: "1",
          label: "医用一次性手套"
        },
        {
          value: "2",
          label: "消毒液"
        },
        {
          value: "3",
          label: "温度枪/红外温度计"
        },
        {
          value: "4",
          label: "防护工作帽"
        },
        {
          value: "5",
          label: "防护鞋套"
        },
        {
          value: "6",
          label: "医用手术衣/床单"
        },
        {
          value: "7",
          label: "民用防护服"
        },
        {
          value: "8",
          label: "医用防护服"
        },
        {
          value: "9",
          label: "医用防护面罩"
        },
        {
          value: "10",
          label: "医用防护眼镜/护目镜"
        },
        {
          value: "11",
          label: "口罩-民用"
        },
        {
          value: "12",
          label: "口罩-医用"
        }
      ],
      classIfy: [],
      option: "",
      value: "",
      option_value: "",
      category: 0,

      purchaser: "",
      title: "",
      product_title: "",
      order_by:'',
      use_sence: "",
      number: "",
      standard: "",
      image: "",
      other: "",
      file_img: {},
      
      sy_name: "",
      loading: false,
      shop_name: "",
      pass: "",
      pass1: "",
      company: "",
      product_number: "",
      serve: this.$store.state.serve,
      token: this.$cookies.get("token"),
      username: this.$cookies.get("username"),
      limit: 10,
      page: null,
      total: null,
      tableData: [],
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      edit_obj: {},
      edit_file: null
    };
  },
  created() {
    this.$store.state.topActiveId = 12;
    this.$store.state.leftTitle = "寻源列表";
    this.geting();
    this.classify();
  },
  watch: {},
  methods: {
    editsubmit() {
      let formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);

      formData.append("id", this.edit_obj.id);
      formData.append("purchaser", this.edit_obj.purchaser);
      formData.append("title", this.edit_obj.title);
      formData.append("product_title", this.edit_obj.product_title);
      formData.append("order_by", this.edit_obj.order_by);
      formData.append("cate_id", this.edit_obj.cate_id);
      formData.append("use_sence", this.edit_obj.use_sence);
      formData.append("number", this.edit_obj.number);
      formData.append("standard", this.edit_obj.standard);
      if (this.edit_file != null) {
        formData.append("image", this.edit_file);
      }
      formData.append("other", this.edit_obj.other);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
       this.axios
        .post(this.serve + "/admin/editSupply", formData, config)
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.dialogFormVisible2 = false;
            // this.$router.push("/bioLook_index");
            this.edit_file = null
            this.geting();
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    indexMethod(row, column, cell, event) {
      this.edit_obj = row;
    },
    classify() {
      this.axios.get(this.serve + "/supplyCateList").then(res => {
        if (res.data.status === "success") {
          this.classIfy = res.data.data;
        }
      });
    },
    change_elect(e) {
      this.category = e;
      this.geting();
    },
    edit_img_file(file) {
      this.edit_file = file.raw;
    },
    prove_img_file(file) {
      this.file_img = file.raw;
    },
    goodsdelete(id) {
      this.axios
        .get(this.serve + "admin/shopForbidden", {
          params: {
            username: this.username,
            token: this.token,
            id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.geting();
            this.$message({
              type: "success",
              message: "操作成功"
            });
          }
        });
    },
    edit(id, page) {
      this.dialogFormVisible2 = true;
    },
    setgoods(id, page) {
      //

      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/delSupply", {
              params: {
                username: this.username,
                token: this.token,
                id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.geting(page);
              } else if (res.data.status == "error") {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    seach() {
      this.geting();
    },
    change_null() {
      this.category = 0;
      this.geting();
    },
    pagechange(page) {
      this.geting(page);
    },
    change_page_num(v) {
      this.limit = v;
      this.geting();
    },
    addsubmit() {
      let param = new FormData();
      param.append("username", this.username);
      param.append("token", this.token);
      param.append("purchaser", this.purchaser);
      param.append("title", this.title);
      param.append("product_title", this.product_title);
      param.append("order_by", this.order_by);

      param.append("cate_id", this.option_value);

      param.append("use_sence", this.use_sence);
      param.append("number", this.number);
      param.append("standard", this.standard);
      param.append("image", this.file_img);
      param.append("other", this.other);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios
        .post(this.serve + "/admin/addSupply", param, config)
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.dialogFormVisible1 = false;
            // this.$router.push("/bioLook_index");
            this.geting();
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    geting(page) {
      this.loading = true;
      this.axios
        .get(this.serve + "/admin/listSupply", {
          params: {
            username: this.username,
            token: this.token,
            category: this.category,
            page
          }
        })
        .then(res => {
          if(res.data.status == 'success')
          {
this.tableData = [];
          this.loading = false;
          if (res.data.status == "success") {
            this.page = res.data.data.page;
            this.total = res.data.data.total;
            this.tableData = res.data.data.results;
          }
          }else{
            if(res.data.msg == '无权访问')
            {
              this.role = false
            }            
          }
          
        });
    }
  }
};
</script>
<style lang="scss">
.shop_list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .binaji {
    cursor: pointer;
    margin-right: 10px;
    margin-left: 10px;
    font-weight: 300;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
  }
  .binaji:hover {
    color: #0099ff;
  }
  .goodslist_bom_page {
    //  height: 80px;
    padding: 13px 0 30px 0;
    text-align: right;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .goodslist_top {
    border: 1px solid rgba(221, 221, 221, 1);
    .goodslist_title {
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      width: 1022px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #333;
      line-height: 46px;
      padding-left: 16px;
      display: flex;
      justify-content: space-between;
      padding-right: 16px;
      align-items: center;
    }
    .goodslost_seach {
      // width: 1060px;
      // line-height: 86px;
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      height: 86px;
      background: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      .goodslost_seach_row {
        width: 100%;
        .goodslost_seach_row_col {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
        }
      }
    }
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  //   .el-pagination {
  //     text-align: left;
  //   }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    //  display: flex;
    //  justify-content: space-between;
    .center_list_head_left {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .center_list_head_left_div {
        display: flex;
      }
      .show_total {
        font-size: 12px;
        width: 100px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        text-align: center;
        cursor: pointer;
        line-height: 30px;
        margin-right: 4px;
      }
      .show_total:hover {
        color: #3498db;
      }
      .show_total_span:hover {
        color: #3498db;
      }
    }

    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>